import { render, staticRenderFns } from "./PageWineApprovedRight.vue?vue&type=template&id=6567da1e"
import script from "./PageWineApprovedRight.vue?vue&type=script&lang=ts"
export * from "./PageWineApprovedRight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports